const SESSION_KEY = 'xinjian_admin_session'
const SESSION_EXPIRED_EVENT = 'xinjian:admin-session-expired'

function readSession() {
  try {
    const raw = window.localStorage.getItem(SESSION_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (error) {
    return null
  }
}

export function getSession() {
  return readSession()
}

export function getSessionToken() {
  const session = readSession()
  return session && session.sessionToken ? session.sessionToken : ''
}

export function getCsrfToken() {
  const match = document.cookie.match(/(?:^|;\s*)yx_admin_csrf=([^;]+)/)
  return match ? decodeURIComponent(match[1]) : ''
}

export function getStoredUser() {
  const session = readSession()
  return session && session.user ? session.user : null
}

export function setSession(user) {
  window.localStorage.setItem(SESSION_KEY, JSON.stringify({
    user
  }))
}

export function clearSession() {
  window.localStorage.removeItem(SESSION_KEY)
}

export function isSessionExpiredError(error) {
  return !!(error && error.status === 401)
}

export function handleSessionExpired(error) {
  if (!isSessionExpiredError(error)) return false
  clearSession()
  if (typeof window !== 'undefined' && window.dispatchEvent) {
    window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT))
  }
  return true
}

export { SESSION_EXPIRED_EVENT }
